import * as AseguradoRepository from "../../services/repositories/asegurado-repository";
import * as Constantes from '../../utils/constantes'
import * as ContratanteRepository from "../../services/repositories/contratante-repository";
import * as CuestionarioRepository from "../../services/repositories/cuestionario-repository";
import * as FamiliarRepository from "../../services/repositories/familiar-repository";
import * as Funciones from '../../utils/funciones'
import * as GeneralActions from '../../store/actions/generalActions'
import * as Globales from '../../utils/globales'
import * as ProductoRepository from "../../services/repositories/producto-repository";
import * as SolicitudRepository from "../../services/repositories/solicitud-repository"

import React, { useContext, useEffect, useState } from 'react'

import Adicionales from '../../components/Adicionales/Adicionales'
import AdicionalesAseguradoAdicional from '../../components/AdicionalesAseguradoAdicional'
import AdicionalesOtroProd from '../../components/AdicionalesOtroProd'
import CargarImagenCita from '../../components/CargarImagenCita/CargarImagenCita'
import CargarImagenCitaAdicional from  '../../components/CargarImagenCitaAdicional/CargarImagenCitaAdicional'
import Contacto from '../../components/Contacto'
import ContactoAdicional from '../../components/ContactoAdicional'
import Conyuge from '../../components/Conyuge'
import Footer from '../../components/Footer'
import GeneralContext from '../../context/GeneralContext'
import Header from '../../components/Header'
import Hijo from '../../components/Hijo'
import Identificacion from '../../components/Identificacion'
import IdentificacionAdicional from '../../components/IdentificacionAdicional'
import Laboral from '../../components/Laboral/Laboral'
import LaboralAdicional from '../../components/LaboralAdicional/LaboralAdicional'
import LaboralOtroProd from '../../components/LaboralOtroProd'
import Modal from '../../components/Modals'
import OrigenFondos from '../../components/OrigenFondos'
import PesoTalla from '../../components/PesoTalla'
import SubMenu from '../../components/SubMenu'
import Subtitle from '../../components/Subtitle'
import styles from './Asegurado.module.css'

//Utiles




















const Asegurado = ({ history }) => {
  const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
  
  let user = generalState.users.filter(user => user.isAuthenticated)[0]
  let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
  let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

  let photo = generalState.photos.asegurado
  let photoAdicional = generalState.photosAdicional.asegurado
  //asrivera: variables para obetener la extension de las imagenes frontal y posterior de adjuntos
  let pruebaPhotoFrontal = (photo.frontal).split(";", 1)
  let pruebaPhoto2Frontal = pruebaPhotoFrontal[0].split("/", 2)
  let pruebaPhotoPosterior = (photo.posterior).split(";", 1)
  let pruebaPhoto2Posterior = pruebaPhotoPosterior[0].split("/", 2)

  let pruebaPhotoAdicionalFrontal = (photoAdicional.frontal).split(";", 1)
  let pruebaPhotoAdicional2Frontal = pruebaPhotoAdicionalFrontal[0].split("/", 2)
  let pruebaPhotoAdicionalPosterior = (photoAdicional.posterior).split(";", 1)
  let pruebaPhotoAdicional2Posterior = pruebaPhotoAdicionalPosterior[0].split("/", 2)


  const initialState = {
    estaCargando: true,
    errorCargando: null,
    asegurado: null,
    aseguradoAdicional: null,
    conyuge: {},
    listaFamiliares: [],
    laboral: null,
    preguntas: [],
    preguntasAdicional: [],
    reloadValidacion: false,
    campoValidadoAdicional: {
      emailRepetido:true,
      correoElectronico:true,
      telefonoMovil:true,
      ingresoAnual: true,
      empresa:true,
      NIT1: true,
      pais: [],
      NIT: [],
      noTieneNIT: true,
      noTieneNITDesc: true,
      credito: true,
      entidad: true,
      //Adicionales
      titular: [],
      compania: [],
      emision: [],
      tipoPlan: [],
      sumaAsegurada: [],
      prestamo: [],
      tipoAsegurado: true,
      peso: true,
      estatura: true,
    },
    campoValidado: {
      //Identificacion
      tipoDocumento: true,
      numeroDocumento: true,
      //Contacto
      celular: true,
      email: true,
      distrito: true,
      direccion: true,
      //TODO
      //Datos Conyuge
      nombres: true,
      apellidoPaterno: true,
      apellidoMaterno: true,
      tipoDocumentoConyuge: true,
      numeroDocumentoConyuge: true,
      ocupacion: true,
      sexo: true,
      fechaNacimiento: true,
      //Lista Familiares
      sexoH: true,
      cantidadH: true,
      //Laboral
      empleadorEmpresa: true,
      giro: true,
      cargo: true,
      ocupacionL: true,
      tipoLabores: true,
      ingresoAnual: true,
      profesion: true,
      //Adicionales
      titular: [],
      compania: [],
      emision: [],
      tipoPlan: [],
      sumaAsegurada: [],
      prestamo: [],
      tipoAsegurado: true,
      peso: true,
      estatura: true,
      //Subpregunta1
      NIT1: true,
      //Subpregunta2
      pais: [],
      NIT: [],
      noTieneNIT: true,
      noTieneNITDesc: true,
      //Endoso
      credito: true,
      entidad: true,
      //Origen Fondo
      origenFondo: true,
    },
    hijoSeleccionado: null,
    campoValidadoHijo: {
      tipoDocumento: true,
      numeroDocumento: true,
      nombres: true,
      apellidoPaterno: true,
      apellidoMaterno: true,
      ocupacion: true,
      fechaNacimiento: true,
      sexo: true
    },
    modalInsertar: false,
    modalBorrar: false,
    estaCargandoEcommerce: true,
    autorizacionEcommerce: null,
    distritosEcommerce: [],
    estaCargandoDistritos: true,
    confProducto: null,
    peso: null,
    estatura: null,
    modalTamanio: false,
    activaLlamado: false,
    noBloqueo: false,
    listaPolizas: [],
    tieneRT: false,
    igualNroPol: true,
    subPreguntas: [],
    subPreguntasAdicional: [],
    detalle1: {
      NIT: null
    }, 
    detalle1Adicional: {
      NIT: null
    },
    detalle2: [
      {
        pais: null,
        NIT: null
      }
    ],
    detalle2Adicional: [
      {
        pais: null,
        NIT: null
      }
    ],
    noTieneNIT: 0,
    noTieneNITDesc: null,
    noTieneNITAdicional: 0,
    noTieneNITDescAdicional: null,
    imagenCita: null,
    imagenCitaAdicional: null,
    //Endoso bancario
    credito: null,
    entidad: null,
    esAseguradoAdicional: false,
    preguntasListaAdicional: [], 
  }

  const textos = [
    'Importante',
    'Debes responder la(s) pregunta(s) en la sección "Adicional"'
  ]

  const [mostrarModal, setModal] = useState(false)
  const [mostrarModal2, setModal2] = useState(false)

  const [mostrarModalAdicinoal2, setModalAdicional2] = useState(false)

  const [state, setState] = useState(initialState)
  const [ac, setAc] = useState(true)
  const [mostrarConyuge, setMostrarConyuge] = useState(0)
  const [apFamiliar, setApFamiliar] = useState(false)
  const [reHijos, setReHijos] = useState(false)
  const [reConyuge, setReConyuge] = useState(false)

  const [mostrarMensajes, setMostrarMensajes] = useState(false)
  const [mensajes, setMensajes] = useState([])
  const [product, setProduct] = useState([])
  const [questions, setQuestions] = useState([]);
  const [endosoBancarioPreload, setEndosoBancarioPreload] = useState([])
  const [flagDeclJurada, setflagDeclJurada] = useState(null)
  const DATA = {
    MIN:1,
    PESO_MAX:300,
    ESTATURA_MAX:270
  }

  const CAMPO = {
    PESO: 'peso',
    ESTATURA: 'estatura'
  }

  const [tap, setTap] = useState(1)

  const mostrarPopup = () => {
    setModal(!mostrarModal)
  }

  const armarDetalleSubpreguntas = (subrespuestas) => {
    if (subrespuestas.length !== 0) {
      let detail1 = null
      let detail2 = []
      let noNit = null
      let noNitDesc = null

      subrespuestas.map(subrespuesta => {
        if (subrespuesta.idBancoPregunta === 57 || subrespuesta.idBancoPregunta === 59) {
          if (subrespuesta.respuesta === 1) {
            let nuevo = JSON.parse(subrespuesta.detalle[0].valor)
            detail1 = {
              NIT: nuevo[0].valor
            }
          } else {
            detail1 = null
          }
        }

        if (subrespuesta.idBancoPregunta === 58 || subrespuesta.idBancoPregunta === 60) {
          if (subrespuesta.respuesta === 1) {
            let dets = subrespuesta.detalle.map(det => {
              return JSON.parse(det.valor)
            })
            
            let nuevo = dets.map(det => {
              return det.reduce(function(a, c) {
                if (c.campo === 'pais' || c.campo === 'NIT') {
                  a[c.campo] = c.valor
                } else {
                    if (c.campo === 'noTieneNIT') noNit = c.valor
                    else if (c.campo === 'noTieneNITDesc') noNitDesc = c.valor
                }
                return a
              }, {})
            })
            detail2 = nuevo
          } else {
            detail2 = null
          }
        }
      })

      return {
        det1: detail1,
        det2: detail2,
        det3: noNit,
        det4: noNitDesc
      }
    } else {
      return {
        det1: null,
        det2: null,
        det3: null,
        det4: null
      }
    }
  }

  const cargarDatosIniciales = async () => {
    let rt = null
    if (cotizacion.asegurado.respuestas.length === 0) {
      generalDispatch(GeneralActions.cleanAseguradoField(undefined, false))
      rt = false
    } else {
      let pregunta = cotizacion.asegurado.respuestas.find(r => r.idBancoPregunta === 3 || r.idBancoPregunta === 44)
      if (pregunta !== undefined && pregunta.respuesta === 1 && cotizacion.listaDetalleReemplazo !== undefined) {
        rt = true
      } else {
        generalDispatch(GeneralActions.cleanAseguradoField(undefined, true))
        rt = false
      }
    }

    const obtenerAsegurado = async () => {
      setApFamiliar(cotizacion.esAPFamiliar)
      setAc(cotizacion.esDistintoAsegurado)
      setReHijos(cotizacion.requiereIngresoHijos)
      setReConyuge(cotizacion.requiereFirmaConyuge)
      const response = await AseguradoRepository.obtenerAsegurado(cotizacion.idSolicitudMultiple)
      if(response.error === null) {
        let detalles = armarDetalleSubpreguntas(response.asegurado.subRespuestas !== undefined ?
          response.asegurado.subRespuestas : [])
        setState((state) => {
          return {
            ...state,
            asegurado: {
              ...cotizacion.asegurado,
              subRespuestas: response.asegurado.subRespuestas === null ? [] : response.asegurado.subRespuestas,
            },
            laboral: response.asegurado.laboral,
            peso: response.asegurado.peso,
            estatura: response.asegurado.estatura?.replace('.', ''),
            listaSolicitudes: listarSolicitudes(),
            tieneRT: rt,
            detalle1: detalles.det1 !== null ? detalles.det1 : state.detalle1,
            detalle2: detalles.det2 !== null ? detalles.det2 : state.detalle2,
            noTieneNIT: detalles.det3 !== null ? detalles.det3 : state.noTieneNIT,
            noTieneNITDesc: detalles.det4 !== null ? detalles.det4 : state.noTieneNITDesc,
            credito: cotizacion.solicitudes[0].codigoTipoCreditoEndoso,
            entidad: cotizacion.solicitudes[0].codigoEntidadEndoso
          }
        })
        await obtenerFamiliares()
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
      }
    }

    const obtenerFamiliares = async () => {
      const response = await FamiliarRepository.obtenerFamiliares(cotizacion.idSolicitudMultiple)
      if(response.error === null) {
        let conyuge = response.familiares.filter((familia) => familia.parentesco.codigo === 1)[0]
        if (cotizacion.asegurado !== undefined) {
          setMostrarConyuge(cotizacion.asegurado.estadoCivil.codigo)
        }

        let hijos = null
        if (response.familiares.length > 0 && conyuge === undefined) {
          hijos = response.familiares.filter((familia) => familia.parentesco.codigo !== 1)
        } else if (response.familiares.length > 0) {
          hijos = response.familiares.filter((familia) => familia.parentesco.codigo !== 1)
        }

        setState((state) => {
          return {
            ...state,
            conyuge: conyuge ? conyuge : null,
            listaFamiliares: hijos === null ? [] : hijos,
            aseguradoAdicional: response.familiares.filter((item) => item.indicadorAseguradoAdicional === 1)[0]
          }
        })
        await obtenerProductoConfiguracion()

        let esAseguradoAdicionalAux = false
        cotizacion.solicitudes.map(solicitud => {
          esAseguradoAdicionalAux = solicitud.indicadorAseguradoAdicional
        })

        if(esAseguradoAdicionalAux){
          await obtenerFamiliaresAdjuntos(response.familiares.filter((item) => item.indicadorAseguradoAdicional === 1)[0])
        } else {
          setState((state) => {
            return {
              ...state,
              aseguradoAdicional: {
                ...state.aseguradoAdicional,
                adjuntos: []
              }
            }
          })
        }


      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
      }
    }

    const obtenerFamiliaresAdjuntos = async (familiar) => {
      const response = await FamiliarRepository.obtenerFamiliaresAdjuntosTipo(cotizacion.idSolicitudMultiple, familiar?.idFamiliar, 3)
      if(response.error === null) {
        setState((state) => {
          return {
            ...state,
            aseguradoAdicional: {
              ...state.aseguradoAdicional,
              adjuntos: response.familiares,
              usuario: user.info.IdUsuario
            }
          }
        })
        for (const adjunto of response.familiares) {
          if(adjunto.cargado){
            if (adjunto.descripcion.includes('frontal')) {
              generalDispatch(GeneralActions.setPhotoAdicional(Funciones.pintarBase64(adjunto.archivo), 'frontal', 'asegurado'))
            } else if (adjunto.descripcion.includes('posterior')) {
              generalDispatch(GeneralActions.setPhotoAdicional(Funciones.pintarBase64(adjunto.archivo), 'posterior', 'asegurado'))
            }
          }
        }
        await obetenerSubPreguntas(familiar);
      }
    }

    const obetenerSubPreguntas = async (familiar) => {
      const response = await FamiliarRepository.obtenerFamiliar(cotizacion.idSolicitudMultiple, familiar)
      if(response.error === null) {

        let detalles = armarDetalleSubpreguntas(response.familiares.subRespuestas !== undefined ? response.familiares.subRespuestas : [])

        setState((state) => {
          return {
            ...state,
            aseguradoAdicional: {
              ...state.aseguradoAdicional,
              subRespuestas : response.familiares.subRespuestas === null ? [] : response.familiares.subRespuestas,
              respuestas: response.familiares.respuestas === null ? [] : response.familiares.respuestas,
              otrosSeguros : response.familiares.otrosSeguros
            },
            detalle1Adicional: detalles.det1 !== null ? detalles.det1 : state.detalle1Adicional,
            detalle2Adicional: detalles.det2 !== null ? detalles.det2 : state.detalle2Adicional,
            noTieneNITAdicional: detalles.det3 !== null ? detalles.det3 : state.noTieneNITAdicional,
            noTieneNITDescAdicional: detalles.det4 !== null ? detalles.det4 : state.noTieneNITDescAdicional,
          }
        })
      }
    }

    const obtenerProductoConfiguracion = async () => {
      let mostrarDS = false
      for (const producto of cotizacion.productos) {
        const response = await ProductoRepository.obtenerConfiguracionProducto(producto.codigoProducto, producto.codigoVersionProducto)
        if(response.error === null) {
          if (response.configuracion.flagIsCuestionarioVic) {
            mostrarDS = response.configuracion.flagIsCuestionarioVic
            break
          }
        } else {
          generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        }
      }
      setState((state) => {
        return {
          ...state,
          confProducto: mostrarDS,
          activaLlamado: true
        }
      })
    }

    const listarSolicitudes = () => {
      let listaSolicitudes = cotizacion.solicitudes.map(solicitud => {
        
          let producto = cotizacion.productos.filter(producto => producto.codigoProducto === solicitud.codigoProducto)[0]
          return {
              numeroSolicitud: solicitud.numeroSolicitud,
              codigoProducto: solicitud.codigoProducto,
              descripcion: producto.descripcion,
              tipoProducto: producto.codigoTipoProducto,
              idSolicitud: solicitud.idSolicitud,
              endosoMaximo: solicitud.endosoMaximo,
          }
      })

      return listaSolicitudes
    }
    const obtenerSolicitudes = async () => {
      const response = await SolicitudRepository.obtenerSolicitudes(cotizacion.idSolicitudMultiple)
      if(response.error === null) {
        setProduct(response.solicitudes.productos)
        setEndosoBancarioPreload(response.solicitudes.solicitudes[0]?.endosoBancario || [])
        setflagDeclJurada(response.solicitudes.flagDeclaracionJurada)
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
      }
    }


    generalDispatch(GeneralActions.updateEstadoCargando(true))
    await flagEsAseguradoAdicional()
    await obtenerAsegurado()
    await obtenerSolicitudes()
    generalDispatch(GeneralActions.updateEstadoCargando(false))
    
  }

  const flagEsAseguradoAdicional = async () => {
    let esAseguradoAdicional = false
    cotizacion.solicitudes.map(solicitud => {
        esAseguradoAdicional = solicitud.indicadorAseguradoAdicional
    })
    setState((state) => {
        return {
            ...state,
            esAseguradoAdicional: esAseguradoAdicional
        }
    })
}

  const cargarPreguntasAdicionales = () => {
    let preguntasAdicional = []
    let grupoPregunta = 0
    const actuPreguntas = cotizacion.preguntasAdicional.map((pregunta) => {
      let retorna = false
      let tipoDetalle = null
      Globales.PREGUNTAS_INICIALES_ADICIONAL.map(preguntaGlobal => {
          if (preguntaGlobal.codigo === pregunta.idBancoPregunta && (preguntaGlobal.grupo === grupoPregunta || grupoPregunta === 0)) {
              retorna = true
              tipoDetalle = preguntaGlobal.tipoDetalle
          }
          return preguntaGlobal
      })

      if (retorna) {
          preguntasAdicional.push(pregunta)
      }
      return pregunta
    })
    setState((state) => {
      return {
        ...state,
        preguntasListaAdicional: preguntasAdicional
      }
    })
  }

  useEffect(() => {
    cargarDatosIniciales()
    cargarPreguntasAdicionales()
  }, [])

  // Los codigoProducto 176 y 177 deben desabilitar la pregunta 5
  const hasCodigoProductoDisabled = product?.some(item => item.codigoProducto === "176" 
      || item.codigoProducto === "177" );
const montoInvalidezTotalPermanente = state.listaSolicitudes?.reduce((max, solicitud) => 
  solicitud.endosoMaximo > max ? solicitud.endosoMaximo : max, 0);

useEffect(() => {
  if(!montoInvalidezTotalPermanente) {
    setQuestions(state.preguntas.filter((pregunta) =>  pregunta.idBancoPregunta !== 115));
  }else if (!flagDeclJurada) {
    setQuestions(state.preguntas.filter((pregunta) =>  pregunta.idBancoPregunta !== 14));
  }
  else{
    setQuestions(state.preguntas);
  }
}, [montoInvalidezTotalPermanente,state.preguntas, flagDeclJurada]);

  const validarPantalla = async () => {
    
    let validado = true

    const asignarValidacionCampo = (campo, valor, index) => {
      validado = validado && valor
      if (index === undefined) {
        setState((state) => {
          return {
            ...state,
            campoValidado: {
              ...state.campoValidado,
              [campo]: valor
            }
          }
        })
      } else {
        let campoValidacion = state.campoValidado[campo]
        campoValidacion[index] = valor
        setState((state) => {
          return {
            ...state,
            campoValidado: {
              ...state.campoValidado,
              [campo]: campoValidacion
            }
          }
        })
      }
    }

    const asignarValidacionCampoAdicional = (campo, valor, index) => {
      validado = validado && valor
      if (index === undefined) {
        setState((state) => {
          return {
            ...state,
            campoValidadoAdicional: {
              ...state.campoValidadoAdicional,
              [campo]: valor
            }
          }
        })
      } else {
        let campoValidacion = state.campoValidadoAdicional[campo]
        campoValidacion[index] = valor
        setState((state) => {
          return {
            ...state,
            campoValidadoAdicional: {
              ...state.campoValidadoAdicional,
              [campo]: campoValidacion
            }
          }
        })
      }
    }

    const validarCombo = (objeto, campoValidacion, campo, index) => {
      if (objeto === null || objeto[campo] === null ||
        objeto[campo] === undefined ||
        objeto[campo].codigo === null ||
        objeto[campo].codigo === 0 ||
        objeto[campo] === '0') {
        asignarValidacionCampo(campoValidacion, false, index)
      } else {
        asignarValidacionCampo(campoValidacion, true, index)
      }
    }

    const validarComboAdicional = (objeto, campoValidacion, campo, index) => {
      if (objeto === null || objeto[campo] === null ||
        objeto[campo] === undefined ||
        objeto[campo].codigo === null ||
        objeto[campo].codigo === 0 ||
        objeto[campo] === '0') {
        asignarValidacionCampoAdicional(campoValidacion, false, index)
      } else {
        asignarValidacionCampoAdicional(campoValidacion, true, index)
      }
    }

    const validarRadio = (objeto, campoValidacion, campo) => {
      if (objeto === null || objeto[campo] === null ||
        objeto[campo] === undefined ||
        objeto[campo].codigo === null ||
        objeto[campo] === '') {
        asignarValidacionCampo(campoValidacion, false)
      } else {
        asignarValidacionCampo(campoValidacion, true)
      }
    }

    const validarTexto = (objeto, campoValidacion, campo, index) => {
      if (campoValidacion === 'ingresoAnual') {
        if (isNaN(objeto[campo]) || objeto[campo] === 0) {
          asignarValidacionCampo(campoValidacion, false, index)
        }
      } else if (objeto === null || objeto[campo] === undefined ||
        objeto[campo] === '' || objeto[campo] === null) {
        asignarValidacionCampo(campoValidacion, false, index)
      } else {
        asignarValidacionCampo(campoValidacion, true, index)
      }
    }

    const validarTextoAdicional = (objeto, campoValidacion, campo, index) => {
      if (campoValidacion === 'ingresoAnual') {
        if (isNaN(objeto[campo]) || objeto[campo] === 0) {
          asignarValidacionCampoAdicional(campoValidacion, false, index)
        }
      } else if (objeto === null || objeto[campo] === undefined ||
        objeto[campo] === '' || objeto[campo] === null) {
          asignarValidacionCampoAdicional(campoValidacion, false, index)
      } else {
        asignarValidacionCampoAdicional(campoValidacion, true, index)
      }
    }

    const validarNumero = (objeto, campoValidacion, campo) => {
      if (objeto === undefined ||
        objeto === null ||
        objeto[campo] === null ||
        objeto[campo] === undefined ||
        objeto[campo] === '' ||
        objeto[campo] === 0 || isNaN(objeto[campo])) {
        asignarValidacionCampo(campoValidacion, false)
      } else {
        if(campoValidacion == CAMPO.PESO || campoValidacion == CAMPO.ESTATURA){
          validarPesoAltura(campoValidacion)
        }else{
          asignarValidacionCampo(campoValidacion, true)
        }
      }
    }

    const validarPesoAltura = () => {
      const peso = Number(state.peso)
      const estatura = Number(state.estatura)
      if (Number.isInteger(peso) && peso >= DATA.MIN && peso <= DATA.PESO_MAX) {
        asignarValidacionCampo(CAMPO.PESO, true)
      }else {
        generalDispatch(GeneralActions.updateError({mensajeRespuesta:"Ingrese un PESO Válido."}, '¡Alerta!', true))
        asignarValidacionCampo(CAMPO.PESO, false)
      }
      if(Number.isInteger(estatura) && estatura >= DATA.MIN && estatura <= DATA.ESTATURA_MAX) {
        asignarValidacionCampo(CAMPO.ESTATURA, true)
      } else{
        generalDispatch(GeneralActions.updateError({mensajeRespuesta:"Ingrese una ESTATURA Válida."}, '¡Alerta!', true))
        asignarValidacionCampo(CAMPO.ESTATURA, false)
      }
    }

    const validarNumeroAdicional = (objeto, campoValidacion, campo) => {
      if (objeto === undefined ||
        objeto === null ||
        objeto[campo] === null ||
        objeto[campo] === undefined ||
        objeto[campo] === '' ||
        objeto[campo] === 0 || isNaN(objeto[campo])) {
        asignarValidacionCampoAdicional(campoValidacion, false)
      } else {
        asignarValidacionCampoAdicional(campoValidacion, true)
      }
    }

    const invocarGuardarContratanteOtrosDatos = async () => {
      const producto = []
      for (const prod of cotizacion.productos) {
        producto.push(
          {
            "codigoCobertura": prod.coberturas[0].codigoCobertura,
            "codigoProducto": prod.codigoProducto,
            "codigoVersionProducto": prod.codigoVersionProducto,
            "respuestaReflex": true
          }
        )
      }

      let aseguradoAuxPost = {
        "assessmentId": "",
        "coberturas": producto,
        "usuario": user.info.IdUsuario,
        "peso": state.peso,
        "estatura": state.estatura.slice(0, 1) + '.' + state.estatura.slice(1),
        "codigoGiroEmpresa": state.asegurado.laboral.giro.codigo,
        "codigoCargo": state.asegurado.laboral.cargo.codigo,
        "codigoProfesion": state.asegurado.laboral.profesion.codigo,
        "codigoOcupacion": state.asegurado.laboral.ocupacion.codigo,
        "codigoActividad": state.asegurado.laboral.tipoLabores.codigo,
      }

      const response = await CuestionarioRepository.guardarCuestionario(cotizacion.idSolicitudMultiple, aseguradoAuxPost)
      if(response.error !== null) {
        generalDispatch(generalDispatch.updateError(response.error, '¡Alerta!'))
      }
    }

    const actualizarSolicitud = async (solicitud) => {
      let solicitudAux = {
        marcaLpdp: cotizacion.lpdp,
        marcaAdicionalLpdp: cotizacion.lpdpAdicional,
        solicitud: {
          idSolicitud: solicitud.idSolicitud,
          beneficiarioMultiple: solicitud.beneficiarioMultiple,
          indicadorAseguradoCobraBeneficio: solicitud.indicadorAseguradoCobraBeneficio,
          condicionCesionDerechos: solicitud.condicionCesionDerechos,
          endosoBancario: state.endosoBancario,
        }
      }

      const response = await SolicitudRepository.actualizarSolicitud(cotizacion.idSolicitudMultiple, solicitudAux.marcaLpdp, solicitudAux.marcaAdicionalLpdp, solicitudAux.solicitud)
      if (response.error === null) {
        generalDispatch(GeneralActions.updateSolicitud(solicitudAux))
        return true
      } else {
        const replyMessage = response.error.mensajeRespuesta;
        const cleanMesagge = replyMessage.split(':').slice(1).join(':').trim();
        const updateError = {
            ...response.error,
            mensajeRespuesta: cleanMesagge
        };
        generalDispatch(GeneralActions.updateError(updateError, Constantes.ALERT_MESSAGE))
        return false
      }
    }

    const invocarGuardarAseguradoAdicional = async () => {
      if (cotizacion.flagDeclaJurada) {
        let pregunta = state.aseguradoAdicional.respuestas.find(r => r.idBancoPregunta === 14 || r.idBancoPregunta === 52)
        if (pregunta !== undefined && pregunta.respuesta === 1) {
          let subRptas = state.aseguradoAdicional.subRespuestas.map(sub => {
            if (sub.respuesta === 1) {
              if (sub.idBancoPregunta === 57 || sub.idBancoPregunta === 59) {
                let arrayV1 = []
                let pasarToStr1 = {
                  valor: JSON.stringify(arrayV1.concat({
                    campo: 'NIT',
                    valor: state.detalle1Adicional.NIT
                  }))
                }
                let nuevo = []
                sub.detalle = nuevo.concat(pasarToStr1)
              } else if (sub.idBancoPregunta === 58 || sub.idBancoPregunta === 60) {
                let detalles = state.detalle2Adicional.map(det => {
                  let arrays = []
                  let names = Object.keys(det).concat(['noTieneNIT', 'noTieneNITDesc'])
                  let values = Object.values(det).concat([state.noTieneNITAdicional, state.noTieneNITDescAdicional])
                  for (let i = 0; i < names.length; i++) {
                    arrays.push({
                      campo: names[i],
                      valor: values[i]
                    })
                  }
                  return {
                    valor: JSON.stringify(arrays)
                  }
                })
                sub.detalle = detalles
              }
            }
            return sub
          })
        }
      }

      let aseguradoAdicionalAuxPut = {}

      aseguradoAdicionalAuxPut = {
        ...state.aseguradoAdicional,
        usuario: user.info.IdUsuario
      }

      const response = await FamiliarRepository.guardarFamiliarAdicional(cotizacion.idSolicitudMultiple, aseguradoAdicionalAuxPut)
      if(response.error === null) {
        return true
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
        return false
      }
    }

    const invocarGuardarAsegurado = async () => {
      /**[INICIO] - Conversiones para guardar los detalles de las subpreguntas de asegurado */
      if (cotizacion.flagDeclaJurada) {
        let pregunta = state.asegurado.respuestas.find(r => r.idBancoPregunta === 14 || r.idBancoPregunta === 52)
        if (pregunta !== undefined && pregunta.respuesta === 1) {
          let subRptas = state.asegurado.subRespuestas.map(sub => {
            if (sub.respuesta === 1) {
              if (sub.idBancoPregunta === 57 || sub.idBancoPregunta === 59) {
                let arrayV1 = []
                let pasarToStr1 = {
                  valor: JSON.stringify(arrayV1.concat({
                    campo: 'NIT',
                    valor: state.detalle1.NIT
                  }))
                }
                let nuevo = []
                sub.detalle = nuevo.concat(pasarToStr1)
              } else if (sub.idBancoPregunta === 58 || sub.idBancoPregunta === 60) {
                let detalles = state.detalle2.map(det => {
                  let arrays = []
                  let names = Object.keys(det).concat(['noTieneNIT', 'noTieneNITDesc'])
                  let values = Object.values(det).concat([state.noTieneNIT, state.noTieneNITDesc])
                  for (let i = 0; i < names.length; i++) {
                    arrays.push({
                      campo: names[i],
                      valor: values[i]
                    })
                  }
                  return {
                    valor: JSON.stringify(arrays)
                  }
                })
                sub.detalle = detalles
              }
            }
            return sub
          })
        }
      }
      /**[FIN] - Conversiones para guardar los detalles de las subpreguntas de asegurado */
   
      let aseguradoAuxPut = {}

      if (state.confProducto) {
        aseguradoAuxPut = {
          ...state.asegurado,
          idSolicitudMultiple: cotizacion.idSolicitudMultiple,
          usuario: user.info.IdUsuario,
          contacto: {
            ...state.asegurado.contacto,
            celular: state.asegurado.contacto.celular.toString()
          },
          laboral: {
            ...state.laboral,
            empleadorEmpresa: state.asegurado.laboral.empleadorEmpresa.trim(),
            ingresoAnual: state.asegurado.laboral.ingresoAnual
          },
          indicadorModificacionDatosPID: state.asegurado.indicadorModificacionDatosPID !== undefined
            ? state.asegurado.indicadorModificacionDatosPID : '1'
        }
      } else {
        aseguradoAuxPut = {
          ...state.asegurado,
          idSolicitudMultiple: cotizacion.idSolicitudMultiple,
          usuario: user.info.IdUsuario,
          contacto: {
            ...state.asegurado.contacto,
            celular: state.asegurado.contacto.celular.toString(),
          },
          laboral: {
            ...state.laboral,
            empleadorEmpresa: state.asegurado.laboral.empleadorEmpresa.trim(),
            ingresoAnual: state.asegurado.laboral.ingresoAnual,
            profesion: state.asegurado.laboral.profesion,
            ocupacion: state.asegurado.laboral.ocupacion,
            giro: state.asegurado.laboral.giro,
            tipoLabores: state.asegurado.laboral.tipoLabores,
            cargo: state.asegurado.laboral.cargo
          },
          indicadorModificacionDatosPID: state.asegurado.indicadorModificacionDatosPID !== undefined
            ? state.asegurado.indicadorModificacionDatosPID : '1'
        }
      }

      const response = await AseguradoRepository.guardarAsegurado(aseguradoAuxPut)
      if(response.error === null) {
        if (!state.noBloqueo) {
          if (response.asegurado.mensaje === "") {
            aseguradoAuxPut.otrosSeguros = response.asegurado.otrosSeguros
            generalDispatch(GeneralActions.setAseguradoProspecto({
              ...aseguradoAuxPut,
            }))
            //para validar si es que tiene esposa-conviviente y si es AP familiar
            if ((mostrarConyuge === 1 || mostrarConyuge === 2) && apFamiliar && reConyuge) {
              let conyugueGuardado = await invocarGuardarConyuge()
              if (conyugueGuardado) {
                if (ac) {
                  return pasarDetReemplazo()
                } else {
                  return await invocarGuardarContratante()
                }
              } else {
                return false
              }
            } else {
              if (ac) {
                return pasarDetReemplazo()
              } else {
                return await invocarGuardarContratante()
              }
            }
          } else {
            setMensajes(['¡Alerta!', response.asegurado.mensaje])
            setMostrarMensajes(true)
            setState((state) => {
              return {
                ...state,
                noBloqueo: true
              }
            })
          }
        } else {
          aseguradoAuxPut.otrosSeguros = response.asegurado.otrosSeguros
          generalDispatch(GeneralActions.setAseguradoProspecto({
            ...aseguradoAuxPut,
          }))
          //para validar si es que tiene esposa-conviviente y si es AP familiar
          if ((mostrarConyuge === 1 || mostrarConyuge === 2) && apFamiliar && reConyuge) {
            let conyugueGuardado = await invocarGuardarConyuge()
            if (conyugueGuardado) {
              if (ac) {
                return pasarDetReemplazo()
              } else {
                return await invocarGuardarContratante()
              }
            } else {
              return false
            }
          } else {
            if (ac) {
              return pasarDetReemplazo()
            } else {
              return await invocarGuardarContratante()
            }
          }
        }
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
      }
    }

    const invocarGuardarContratante = async () => {
      let contratanteAux = null

      if (cotizacion.contratante !== undefined) {
        contratanteAux = {
          usuario: user.info.IdUsuario,
          idContratante: cotizacion.contratante.idContratante,
          idSolicitudMultiple: cotizacion.idSolicitudMultiple,
          apellidoPaterno: state.asegurado.apellidoPaterno,
          apellidoMaterno: state.asegurado.apellidoMaterno,
          nombres: state.asegurado.nombres,
          tipoDocumento: state.asegurado.tipoDocumento,
          numeroDocumento: state.asegurado.numeroDocumento,
          fechaNacimiento: state.asegurado.fechaNacimiento,
          sexo: state.asegurado.sexo,
          nacionalidad: state.asegurado.nacionalidad,
          estadoCivil: state.asegurado.estadoCivil,
          vinculo: {
            codigo: 6 //Valor por Defecto
          },
          tipoPersona: state.asegurado.tipoPersona,
          contacto: {
            ...state.asegurado.contacto,
            celular: state.asegurado.contacto.celular.toString(),
            tipoDireccion: {
              codigo: state.asegurado.tipoPersona.codigo
            }
          },
          laboral: {
            empleadorEmpresa: state.asegurado.laboral.empleadorEmpresa,
            giro: state.laboral.giro,
            cargo: state.laboral.cargo,
            ocupacion: state.laboral.ocupacion,
            tipoLabores: state.laboral.tipoLabores,
            ingresoAnual: Funciones.cantidadStringToFloat(state.asegurado.laboral.ingresoAnual),
            profesion: state.laboral.profesion
          },
          indicadorModificacionDatosPID: state.asegurado.indicadorModificacionDatosPID !== undefined
            ? state.asegurado.indicadorModificacionDatosPID : '1',
        }
      } else {
        contratanteAux = {
          usuario: user.info.IdUsuario,
          idSolicitudMultiple: cotizacion.idSolicitudMultiple,
          apellidoPaterno: state.asegurado.apellidoPaterno,
          apellidoMaterno: state.asegurado.apellidoMaterno,
          nombres: state.asegurado.nombres,
          tipoDocumento: state.asegurado.tipoDocumento,
          numeroDocumento: state.asegurado.numeroDocumento,
          fechaNacimiento: state.asegurado.fechaNacimiento,
          sexo: state.asegurado.sexo,
          nacionalidad: state.asegurado.nacionalidad,
          estadoCivil: state.asegurado.estadoCivil,
          vinculo: {
            codigo: 6 //Valor por Defecto
          },
          tipoPersona: state.asegurado.tipoPersona,
          contacto: {
            ...state.asegurado.contacto,
            celular: state.asegurado.contacto.celular.toString(),
            tipoDireccion: {
              codigo: state.asegurado.tipoPersona.codigo
            }
          },
          laboral: {
            empleadorEmpresa: state.asegurado.laboral.empleadorEmpresa,
            giro: state.laboral.giro,
            cargo: state.laboral.cargo,
            ocupacion: state.laboral.ocupacion,
            tipoLabores: state.laboral.tipoLabores,
            ingresoAnual: Funciones.cantidadStringToFloat(state.asegurado.laboral.ingresoAnual),
            profesion: state.laboral.profesion
          },
          indicadorModificacionDatosPID: state.asegurado.indicadorModificacionDatosPID !== undefined
            ? state.asegurado.indicadorModificacionDatosPID : '1'
        }
      }

      const response = await ContratanteRepository.guardarContratante(contratanteAux)
      if(response.error === null) {
        setState((state) => {
          return {
            ...state,
            contratante: response.contratante
          }
        })
        generalDispatch(GeneralActions.setContratanteCotizacion({
          ...contratanteAux,
          idContratante: response.contratante.idContratante
        }))

        return pasarDetReemplazo()
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
        return false
      }
    }

    const invocarGuardarConyuge = async () => {
      let conyugeAux = {
        ...state.conyuge,
        idSolicitudMultiple: cotizacion.idSolicitudMultiple,
        usuario: user.info.IdUsuario,
        parentesco: {
          codigo: 1
        },
        numeroFamiliar: 1
      }

      const response = await FamiliarRepository.guardarFamiliar(conyugeAux)
      if(response.error === null) {
        return true
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
        return false
      }
    }
    
    /**Guardar reemplazo - traspaso */
    const guardarDetalleReemplazo = async (solicitud) => {
      let requestRT = {
        flagReemplazoTraspaso: 0,
        codigoDocumentoOrigen: null,
        nombreProductoPolizaOrigen: null,
        numeroPoliza: null,
        tipoTraspaso: 0
      }

      if (cotizacion.listaDetalleReemplazo !== undefined && cotizacion.listaDetalleReemplazo !== null) {
        let detalleReemplazo = cotizacion.listaDetalleReemplazo.find(det => det.idSolicitud === solicitud.idSolicitud)
        if (detalleReemplazo !== undefined) {
          let poliza = []
          state.listaPolizas.map(pol => {
            detalleReemplazo.polizas.map(detalle => {
              if (pol.numeroPoliza === detalle.value) {
                poliza.push({
                  ...pol,
                  codigoDocumento: pol.codigoDocumento.toString(),
                  numeroPoliza: pol.numeroPoliza.toString()
                })
              }
              return detalle
            })    
            return pol
          })

          requestRT = {
            flagReemplazoTraspaso: detalleReemplazo.flagReemplazoTraspaso,
            codigoDocumentoOrigen: poliza.length === 1 ? poliza[0].codigoDocumento : poliza.map(p => p.codigoDocumento).join(','),
            nombreProductoPolizaOrigen: poliza.length === 1 ? poliza[0].descripcionProducto : poliza.map(p => p.descripcionProducto).join(','),
            numeroPoliza: poliza.length === 1 ? poliza[0].numeroPoliza : poliza.map(p => p.numeroPoliza).join(','),
            tipoTraspaso: detalleReemplazo.flagReemplazoTraspaso === 1 ? 0 : detalleReemplazo.tipoTraspaso
          }
        }
      }

      let response = await SolicitudRepository.guardarReemplazoTraspaso(solicitud.idSolicitud, requestRT)
      if (response.error === null) {
        let producto = cotizacion.productos.filter(producto => producto.codigoProducto === solicitud.codigoProducto)[0]
        /** CAMUNOZR: No se permite ingresar AP ni producto Vida Inversion Capital al registro de endoso */
        if(producto !== undefined && producto.codigoTipoProducto !== Constantes.COD_TIPO_PRODUCTO_ACCIDENTES_PERSONALES &&
          producto.codigoProducto !== Constantes.COD_PRODUCTO_VIDA_INVERSION_CAPITAL) {
            return await actualizarSolicitud(solicitud)
        }
      } else {
          generalDispatch(GeneralActions.updateError(response.error))
          return false
      }
    }

    const pasarDetReemplazo = async () => {
      let pasar = []
      for (const solicitud of cotizacion.solicitudes) {
        let rpta = await guardarDetalleReemplazo(solicitud)
        pasar.push(rpta)
      }
      let pas = pasar.some(p => p === false)

      return !pas
    }

    //-------------------------------------------Validaciones--------------------------------------
    //Identificacion
    validarCombo(state.asegurado, 'tipoDocumento', 'tipoDocumento')
    validarTexto(state.asegurado, 'numeroDocumento', 'numeroDocumento')

    //Contacto
    validarNumero(state.asegurado.contacto, 'celular', 'celular')
    if (state.asegurado.contacto.celular === null || state.asegurado.contacto.celular === undefined
      || state.asegurado.contacto.celular === ''
      || state.asegurado.contacto.celular.toString().length !== 9) {
      asignarValidacionCampo('celular', false)
    } else {
      asignarValidacionCampo('celular', true)
    }

    let correo = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!state.asegurado.contacto || state.asegurado.contacto.email === ''
      || !state.asegurado.contacto.email.match(correo)) {
      asignarValidacionCampo('email', false)
    } else {
      asignarValidacionCampo('email', true)
    }
    validarCombo(state.asegurado.contacto, 'distrito', 'distrito')
    validarTexto(state.asegurado.contacto, 'direccion', 'direccion')

    //Conyuge
    if (apFamiliar && (mostrarConyuge === 1 || mostrarConyuge === 2) && state.conyuge !== null && reConyuge) {
      validarTexto(state.conyuge, 'nombres', 'nombres')
      validarTexto(state.conyuge, 'apellidoPaterno', 'apellidoPaterno')
      if ((state.conyuge.tipoDocumento === undefined || state.conyuge.tipoDocumento === null
        || state.conyuge.tipoDocumento.codigo === 0) && apFamiliar) {
        asignarValidacionCampo('numeroDocumentoConyuge', false)
        asignarValidacionCampo('tipoDocumentoConyuge', false)
        if (state.conyuge.apellidoMaterno === null || state.conyuge.apellidoMaterno === undefined
          || state.conyuge.apellidoMaterno === '') {
          asignarValidacionCampo('apellidoMaterno', false)
        } else {
          asignarValidacionCampo('apellidoMaterno', true)
        }
      } else if ((state.conyuge.tipoDocumento.codigo === 1 || state.conyuge.tipoDocumento.codigo === 4) && apFamiliar) {
        if (state.conyuge.numeroDocumento === null || state.conyuge.numeroDocumento === undefined
          || state.conyuge.numeroDocumento.match(/[01]{8,}/)
          || state.conyuge.numeroDocumento.match(/12345678.*/)
          || state.conyuge.numeroDocumento === '') {
          asignarValidacionCampo('numeroDocumentoConyuge', false)
        } else {
          asignarValidacionCampo('numeroDocumentoConyuge', true)
        }
        if (state.conyuge.apellidoMaterno === null || state.conyuge.apellidoMaterno === undefined
          || state.conyuge.apellidoMaterno === '') {
          asignarValidacionCampo('apellidoMaterno', false)
        } else {
          asignarValidacionCampo('apellidoMaterno', true)
        }
        asignarValidacionCampo('tipoDocumentoConyuge', true)
      } else if (state.conyuge.tipoDocumento.codigo === 3 && apFamiliar) {
        if (state.conyuge.numeroDocumento === null || state.conyuge.numeroDocumento === undefined
          || state.conyuge.numeroDocumento.match(/[01]{12}/)
          || state.conyuge.numeroDocumento === '') {
          asignarValidacionCampo('numeroDocumentoConyuge', false)
        } else {
          asignarValidacionCampo('numeroDocumentoConyuge', true)
        }
        asignarValidacionCampo('apellidoMaterno', true)
        asignarValidacionCampo('tipoDocumentoConyuge', true)
      } else {
        asignarValidacionCampo('tipoDocumentoConyuge', true)
      }
      validarTexto(state.conyuge, 'fechaNacimiento', 'fechaNacimiento')
      validarCombo(state.conyuge, 'ocupacion', 'ocupacion')
      validarRadio(state.conyuge, 'sexo', 'sexo')
    } else if (apFamiliar && (state.conyuge === null || state.conyuge === undefined)) {
      validarTexto(state.conyuge, 'nombres', 'nombres')
      validarTexto(state.conyuge, 'apellidoPaterno', 'apellidoPaterno')
      validarTexto(state.conyuge, 'apellidoMaterno', 'apellidoMaterno')
      asignarValidacionCampo('tipoDocumentoConyuge', false)
      asignarValidacionCampo('numeroDocumentoConyuge', false)
      validarCombo(state.conyuge, 'ocupacion', 'ocupacion')
      validarTexto(state.conyuge, 'fechaNacimiento', 'fechaNacimiento')
      validarRadio(state.conyuge, 'sexo', 'sexo')
    }

    //FamiliaresHijo
    let index2 = state.listaFamiliares.length
    if (index2 > 0) {
      for (let i = 0; i < index2; i++) {
        if (apFamiliar && ((state.listaFamiliares[i].sexo && state.listaFamiliares[i].sexo.codigo === 2) || state.listaFamiliares[i].sexo === null)) {
          asignarValidacionCampo('sexoH', false)
        } else {
          asignarValidacionCampo('sexoH', true)
        }
      }
    }

    if (apFamiliar && (reHijos && Object.keys(state.listaFamiliares).length === 0)) {
      asignarValidacionCampo('cantidadH', false)
    } else {
      asignarValidacionCampo('cantidadH', true)
    }

    //Laboral
    validarTexto(state.asegurado.laboral, 'empleadorEmpresa', 'empleadorEmpresa')
    validarTexto(state.asegurado.laboral, 'ingresoAnual', 'ingresoAnual')
    if (!state.confProducto) {

      validarNumero(state, 'estatura', 'estatura')
      validarNumero(state, 'peso', 'peso')

      validarCombo(state.asegurado.laboral, 'profesion', 'profesion')
      validarCombo(state.asegurado.laboral, 'ocupacion', 'ocupacion')
      validarCombo(state.asegurado.laboral, 'giro', 'giro')
      validarCombo(state.asegurado.laboral, 'cargo', 'cargo')
      validarCombo(state.asegurado.laboral, 'tipoLabores', 'tipoLabores')
    }

     //VALIDAR SI TIENE ORIGEN DE FONDO
    const isProductVIC = product && product.length > 0 && product[0].codigoProducto === Constantes.COD_PRODUCTO_VIDA_INVERSION_CAPITAL
    if(isProductVIC){
      if(state.asegurado.subRespuestas.some(r => r.idBancoPregunta === Constantes.COD_PREGUNTA_ORIGIN_FONDOS)){
        asignarValidacionCampo('origenFondo', true)
      }else{
        asignarValidacionCampo('origenFondo', false)
      }
    }
    
    //Adicionales Tipo 1
    state.asegurado.otrosSeguros.map((otroSeguro, index) => {
      validarTexto(otroSeguro, 'titular', 'codigoTipoAsegurado', index)
      validarTexto(otroSeguro, 'compania', 'compania', index)
      validarTexto(otroSeguro, 'emision', 'anioEmision', index)
      validarTexto(otroSeguro, 'tipoPlan', 'tipoPlan', index)
      validarTexto(otroSeguro, 'sumaAsegurada', 'sumaAsegurada', index)
      validarTexto(otroSeguro, 'prestamo', 'prestamo', index)
      return otroSeguro
    })

    //Adicionales Tipo 2
    let respuestasTotal = []
    const cotizacion_esDistintoAsegurado = ac
    state.asegurado.respuestas.map(respuestaAsegurado => {
      if (!cotizacion_esDistintoAsegurado) {
        const relevantPreguntaIds = [1, 2, 3, 10, 11, 14, 42, 43, 44, 52, 115];
        if (relevantPreguntaIds.includes(respuestaAsegurado.idBancoPregunta)) {
          if(!flagDeclJurada && respuestaAsegurado.idBancoPregunta === 14) {
            return
          }
          respuestasTotal.push(respuestaAsegurado)
        }
      } else {
        let relevantPreguntaIds = [1, 2, 3, 10, 11, 14, 42, 43, 44, 115];
        if (relevantPreguntaIds.includes(respuestaAsegurado.idBancoPregunta)) {
          respuestasTotal.push(respuestaAsegurado)
        }
      }
      return respuestaAsegurado
    })

    if (state.conyuge !== undefined && state.conyuge !== null && reConyuge) {
      state.conyuge.respuestas && state.conyuge.respuestas.map(respuesta => {
        let repetido = false
        respuestasTotal.map(respuestaAsegurado => {
          if (respuesta.idBancoPregunta === respuestaAsegurado.idBancoPregunta) {
            repetido = true
          }
          return respuestaAsegurado
        })
        if (!repetido) {
          respuestasTotal.push(respuesta)
        }
        return respuesta
      })
    }
    
    //modificar validacion
    if (!hasCodigoProductoDisabled && respuestasTotal.length !== questions.length) {     
          mostrarPopup()
          validado = false
        }
    else if(hasCodigoProductoDisabled && respuestasTotal.length !== questions.length){
      mostrarPopup()
      validado = false
    } else {
      let pregunta = state.asegurado.respuestas.find(r => r.idBancoPregunta === 3 || r.idBancoPregunta === 44)
      if (pregunta !== undefined && pregunta.respuesta === 1) {
        if (cotizacion.listaDetalleReemplazo !== undefined) {
          cotizacion.listaDetalleReemplazo.map(detalleReemplazo => {
            if (detalleReemplazo.idSolicitud !== null) {
              if (detalleReemplazo.flagReemplazoTraspaso === undefined) {
                setMensajes(['Importante', 'Debe seleccionar una opción entre reemplazo y traspaso para poder continuar.'])
                setMostrarMensajes(true)
                validado = false
              } else {
                if (detalleReemplazo.polizas === undefined || (detalleReemplazo && detalleReemplazo.polizas).length === 0) {
                  setMensajes(['Importante', 'Debe seleccionar por lo menos una poliza para el reemplazo o traspaso.'])
                  setMostrarMensajes(true)
                  validado = false
              } else {
                  if (detalleReemplazo.flagReemplazoTraspaso === 2) {
                      if (detalleReemplazo.tipoTraspaso !== undefined && detalleReemplazo.tipoTraspaso !== null) {
                        validado = true
                      } else {
                        setMensajes(['Importante', 'Para el caso de traspaso, debe de seleccionar una opción.'])
                        setMostrarMensajes(true)
                        validado = false
                      }
                  } else {
                    validado = true
                  }
                }
              }
            } else {
              setMensajes(['Importante', 'Debe seleccionar una solicitud para poder continuar.'])
              setMostrarMensajes(true)
              validado = false
            }
            return detalleReemplazo
          })
        } else {
          setMensajes(['Importante', 'Debe seleccionar una solicitud para poder continuar.'])
          setMostrarMensajes(true)
          validado = false
        }
      }

      /**Validaciones pregunta declaracion jurada */
      if (cotizacion.flagDeclaJurada) {
        let preguntaDj = state.asegurado.respuestas.find(r => r.idBancoPregunta === 14 || r.idBancoPregunta === 52)
        if (preguntaDj !== undefined && preguntaDj.respuesta === 1) {
          let subRespuestasTotal = []
          state.asegurado.subRespuestas.map(subRespuesta => {
            if ((subRespuesta.idBancoPregunta === 57 || subRespuesta.idBancoPregunta === 58) ||
              (subRespuesta.idBancoPregunta === 59 || subRespuesta.idBancoPregunta === 60)) {
                subRespuestasTotal.push(subRespuesta)
            }
          })

          if (subRespuestasTotal.length !== state.subPreguntas.length) {
            setMensajes(['Importante', 'Debe responder la(s) subpregunta(s) en la sección "Adicional"'])
            setMostrarMensajes(true)
            validado = false
          } else {
            let pregunta1 = state.asegurado.subRespuestas.find(s => s.idBancoPregunta === 57 || s.idBancoPregunta === 59)
            let pregunta2 = state.asegurado.subRespuestas.find(s => s.idBancoPregunta === 58 || s.idBancoPregunta === 60)

            if (pregunta1.respuesta === 1) {
              if (state.detalle1.NIT === null || state.detalle1.NIT === '')
                asignarValidacionCampo('NIT1', false)
            }

            if (pregunta2.respuesta === 1) {
              state.detalle2.map((det2, index) => {
                validarCombo(det2, 'pais', 'pais', index)
                if (det2.NIT === null || det2.NIT === '') {
                  if (state.noTieneNIT === 0) {
                    asignarValidacionCampo('noTieneNIT', false)
                  } else {
                    if (state.noTieneNIT === 2) {
                      validarTexto(state, 'noTieneNITDesc', 'noTieneNITDesc')
                    }
                  }
                }
                return det2
              })
            }
          }
        }
      }

      /**Validaciones pregunta endoso bancario */
      if (state?.endosoBancario) {
        const endosoBancarioComplete = state.endosoBancario.some(({codigoEntidad, codigoTipoCredito, montoEndosado}) =>
          !codigoEntidad || !codigoTipoCredito || !montoEndosado);
        if (endosoBancarioComplete) {
          setMensajes(['Importante', `Se deben llenar todos los campos de endoso`]);
          setMostrarMensajes(true);
          validado = false;
        }
      
        if (state.endosoBancario.some(endoso => endoso.montoEndosado > montoInvalidezTotalPermanente)) {
          setMensajes(['Importante', `No se puede registrar porque supera el monto de ${montoInvalidezTotalPermanente} (cobertura de Invalidez Total y Permanente)`]);
          setMostrarMensajes(true);
          validado = false;
        }
      }

    }

    //Validar si es asegurado adicional

    if(!validado){
      return false
    }

    if(state.esAseguradoAdicional){
      
      validarCombo(state.aseguradoAdicional, 'tipoDocumento', 'tipoDocumento')
      validarTexto(state.aseguradoAdicional, 'numeroDocumento', 'numeroDocumento')


      //Contacto
      validarNumeroAdicional(state.aseguradoAdicional, 'telefonoMovil', 'telefonoMovil')
      if (state.aseguradoAdicional.telefonoMovil === null || state.aseguradoAdicional.telefonoMovil === undefined
        || state.aseguradoAdicional.telefonoMovil === ''
        || state.aseguradoAdicional.telefonoMovil.toString().length !== 9) {
          asignarValidacionCampoAdicional('telefonoMovil', false)
          setTap(2)
      } else {
        asignarValidacionCampoAdicional('telefonoMovil', true)
      }

      let correoRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!state.aseguradoAdicional.correoElectronico || state.aseguradoAdicional.correoElectronico === ''
        || !state.aseguradoAdicional.correoElectronico.match(correoRegEx)) {
          asignarValidacionCampoAdicional('correoElectronico', false)
          setTap(2)
      } else {
        asignarValidacionCampoAdicional('correoElectronico', true) 
      }

       if( state.aseguradoAdicional.empresa === null || !state.aseguradoAdicional.empresa || state.aseguradoAdicional.empresa === '' )
      {
          asignarValidacionCampoAdicional('empresa', false);
          setTap(2);
      } else {
        asignarValidacionCampoAdicional('empresa', true)
      }

    if(state.aseguradoAdicional.ingresoAnual === 0  ||  isNaN(state.aseguradoAdicional.ingresoAnual) || state.aseguradoAdicional.ingresoAnual === null ||  state.aseguradoAdicional.ingresoAnual === '' )
      {
        asignarValidacionCampoAdicional('ingresoAnual', false);
        setTap(2);
      } else {
        asignarValidacionCampoAdicional('ingresoAnual', true);
      }
      

      if( state.asegurado.contacto.email === state.aseguradoAdicional.correoElectronico){
        asignarValidacionCampoAdicional('emailRepetido', false)
        setTap(2)
      }

      state.aseguradoAdicional.otrosSeguros.map((otroSeguro, index) => {
        validarTextoAdicional(otroSeguro, 'titular', 'codigoTipoAsegurado', index)
        validarTextoAdicional(otroSeguro, 'compania', 'compania', index)
        validarTextoAdicional(otroSeguro, 'emision', 'anioEmision', index)
        validarTextoAdicional(otroSeguro, 'tipoPlan', 'tipoPlan', index)
        validarTextoAdicional(otroSeguro, 'sumaAsegurada', 'sumaAsegurada', index)
        validarTextoAdicional(otroSeguro, 'prestamo', 'prestamo', index)
        return otroSeguro
      })

      //Adicionales Tipo 2
      let respuestasTotalAdicional = []
      state.aseguradoAdicional.respuestas.map(respuestaAsegurado => {
        if (!ac) {
          if ((respuestaAsegurado.idBancoPregunta === 1 || respuestaAsegurado.idBancoPregunta === 2
              || respuestaAsegurado.idBancoPregunta === 3 || respuestaAsegurado.idBancoPregunta === 14) ||
            (respuestaAsegurado.idBancoPregunta === 42 || respuestaAsegurado.idBancoPregunta === 43
              || respuestaAsegurado.idBancoPregunta === 44 || respuestaAsegurado.idBancoPregunta === 52) ||
            (respuestaAsegurado.idBancoPregunta === 10 || respuestaAsegurado.idBancoPregunta === 11 || respuestaAsegurado.idBancoPregunta === 14)
              || respuestaAsegurado.idBancoPregunta === 115) {
                respuestasTotalAdicional.push(respuestaAsegurado)
            }
        } else {
          if ((respuestaAsegurado.idBancoPregunta === 1 || respuestaAsegurado.idBancoPregunta === 2
            || respuestaAsegurado.idBancoPregunta === 3) || (respuestaAsegurado.idBancoPregunta === 42
            || respuestaAsegurado.idBancoPregunta === 43 || respuestaAsegurado.idBancoPregunta === 44) ||
            (respuestaAsegurado.idBancoPregunta === 10 || respuestaAsegurado.idBancoPregunta === 11 || respuestaAsegurado.idBancoPregunta === 14)
            || respuestaAsegurado.idBancoPregunta === 115) {
              respuestasTotalAdicional.push(respuestaAsegurado)
            }
        }
        return respuestaAsegurado
      })
      
      //modificar validacion
      if (!hasCodigoProductoDisabled && respuestasTotalAdicional.length !== state.preguntasListaAdicional.length) {
        mostrarPopup()
        validado = false
      } else if(hasCodigoProductoDisabled && respuestasTotalAdicional.length !== questions.length){
        mostrarPopup()
        validado = false
      } else {
       

        /**Validaciones pregunta declaracion jurada */
        if (cotizacion.flagDeclaJurada) {
          let preguntaDj = state.aseguradoAdicional.respuestas.find(r => r.idBancoPregunta === 14 || r.idBancoPregunta === 52)
          if (preguntaDj !== undefined && preguntaDj.respuesta === 1) {
            let subRespuestasTotalAdicional = []
            state.aseguradoAdicional.subRespuestas.map(subRespuesta => {
              if ((subRespuesta.idBancoPregunta === 57 || subRespuesta.idBancoPregunta === 58) ||
                (subRespuesta.idBancoPregunta === 59 || subRespuesta.idBancoPregunta === 60)) {
                  subRespuestasTotalAdicional.push(subRespuesta)
              }
            })

            if (subRespuestasTotalAdicional.length !== state.subPreguntasAdicional.length) {
              setMensajes(['Importante', 'Debe responder la(s) subpregunta(s) en la sección "Adicional"'])
              setMostrarMensajes(true)
              validado = false
              setTap(2)
            } else {
              let pregunta1 = state.aseguradoAdicional.subRespuestas.find(s => s.idBancoPregunta === 57 || s.idBancoPregunta === 59)
              let pregunta2 = state.aseguradoAdicional.subRespuestas.find(s => s.idBancoPregunta === 58 || s.idBancoPregunta === 60)

              if (pregunta1.respuesta === 1) {
                if (state.detalle1Adicional.NIT === null || state.detalle1Adicional.NIT === '')
                  asignarValidacionCampoAdicional('NIT1', false)
                setTap(2)
              }

              if (pregunta2.respuesta === 1) {
                state.detalle2Adicional.map((det2, index) => {
                  validarComboAdicional(det2, 'pais', 'pais', index)
                  if (det2.NIT === null || det2.NIT === '') {
                    if (state.noTieneNITAdicional === 0) {
                      asignarValidacionCampoAdicional('noTieneNITAdicional', false)
                      setTap(2)
                    } else {
                      if (state.noTieneNITAdicional === 2) {
                        validarTextoAdicional(state, 'noTieneNITDescAdicional', 'noTieneNITDescAdicional')
                      }
                    }
                  }
                  return det2
                })
              }
            }
          }
        }
      }
    }

    if (validado) {
      if (!state.confProducto) {
        await invocarGuardarContratanteOtrosDatos();
      }
      if (state.esAseguradoAdicional) {
        return  await invocarGuardarAsegurado() && await invocarGuardarAseguradoAdicional()
      } else {
        return invocarGuardarAsegurado()
      }
    } else {
      return false
    }
  }

  const [cambia, setCambia] = useState(false)
  const ocultaMensaje = () => {
    setCambia(!cambia)
  }

  const [mover, setMover] = useState(false)
  const mueveContenido = (valor) => {
    setMover(valor)
  }
  return (
    <React.Fragment>
      <Header history={history} />
      <SubMenu
        history={history}
        modal={state.estaCargando || mostrarModal || state.modalInsertar || state.modalBorrar || state.estaCargandoDistritos || state.modalTamanio} // || state.estaCargandoEcommerce}
        desplaza={mueveContenido}
      />
      <section className={styles['areadatosusuario']}
        style={mover ? { width: '93%', paddingLeft: '6.5%', height: '100vh' } : {}}
      >
        {
					state.esAseguradoAdicional ?
            <div>
              <br/><br/>
              <div className={styles['tabsSeleccionarAsegurado']}>
                <div className={ tap === 1 ? styles['tabsSeleccionarAseguradoSelec'] : null}>
                  <a onClick={() => setTap(1)} >Asegurado Principal</a>
                </div>
                <div className={ tap === 2 ? styles['tabsSeleccionarAseguradoSelec'] : null}>
                  <a onClick={() => setTap(2)} >Asegurado Adicional</a>
                </div>
              </div>	
              <br/>
            </div>
            : 
            null
        }
        {
          tap === 1 ?
            <div> 
              <Contacto
                asegurado={state.asegurado}
                state={state}
                setState={setState}
                contacto={state.contacto}
              />

              {apFamiliar ?
                <div className={styles['areadatosprospecto']}>
                  <Subtitle
                    sname='Datos Familiares' />
                  {(mostrarConyuge === 1 || mostrarConyuge === 2) && reConyuge ?
                    <Conyuge
                      conyuge={state.conyuge}
                      state={state}
                      setState={setState}
                      familiar={apFamiliar}
                    />
                    : null
                  }

                  {state && state.listaFamiliares !== null && state.listaFamiliares.length > 0 && reHijos ?
                    <Hijo
                      state={state}
                      setState={setState}
                      familiares={state && state.listaFamiliares}
                      idSolicitudMultiple={cotizacion.idSolicitudMultiple}
                      usuario={user.info.IdUsuario}
                      producto={apFamiliar}
                    />
                    : null
                  }
                </div>
                : null
              }

              {
                state.confProducto !== null ?
                  !state.confProducto ?
                  <PesoTalla
                    peso={state.peso}
                    estatura={state.estatura}
                    state={state}
                    setState={setState}
                  />
                  : null
                : null
              }

              {
                state.confProducto !== null ?
                  state.confProducto ?
                    <Laboral
                      asegurado={state.asegurado}
                      state={state}
                      setState={setState}
                    />
                    : 
                    <LaboralOtroProd
                      asegurado={state.asegurado}
                      state={state}
                      setState={setState}
                    />
                  : null
              }
              {
                product && product[0] && product[0].codigoProducto === Constantes.COD_PRODUCTO_VIDA_INVERSION_CAPITAL &&
                <OrigenFondos 
                  state={state}
                  setState={setState}
                  product={product[0]}
                />
              }

              {
                state.confProducto !== null ?
                  state.confProducto ?
                    <Adicionales
                      state={state}
                      setState={setState}
                      paginaActual={'asegurado'}
                      listaSolicitudes={state.listaSolicitudes}
                      product={product}
                      endosoBancarioPreload = {endosoBancarioPreload}
                    />
                    : <AdicionalesOtroProd
                      state={state}
                      setState={setState}
                      paginaActual={'asegurado'}
                    />
                  : null
              }
            </div>
          : 
            <div>
              <ContactoAdicional
                aseguradoAdicional={state.aseguradoAdicional}
                state={state}
                setState={setState}
              />
				<LaboralAdicional
					aseguradoAdicional={state.aseguradoAdicional}
					state={state}
					setState={setState}
				/>
              <AdicionalesAseguradoAdicional
                state={state}
                setState={setState}
                paginaActual={'aseguradoAdicional'}
                listaSolicitudes={state.listaSolicitudes}
                product={product}
              />
            </div>          
        }
        <Modal mostrarModal={mostrarModal} setModal={setModal} textos={textos} />
        <Modal mostrarModal={mostrarMensajes} setModal={setMostrarMensajes} textos={mensajes} estilos={{whiteSpace: 'break-spaces'}} />
        <Footer history={history} validarPantalla={validarPantalla} />
      </section>
    </React.Fragment>
  )
}

export default Asegurado